export const ALLOWED = 'ALLOWED';
export const DISALLOWED = 'DISALLOWED';
export const BLOCKED = 'BLOCKED';